/**
 * 予約フォームのオプション制御
 */

jQuery( function ($) {
	// 選択肢によって項目が変わる
	const plan = $('#booking-option-plan');
	plan.on('change', function() {
		const value = $(this).val();
		$('tr[class^="plan_detail_"]').hide();
		$('tr[class^="plan_detail_"]').find('.booking-option-select').val('');
		$('.plan_detail_' + value).show();
	});

	// 確認画面制御
	$('tr[id^="confirmation-plan_detail_"]').each((index, e) => {
        const $tr = $(e);
        const hiddenInputs = $tr.find('input[type="hidden"]');
		console.log(hiddenInputs);
        hiddenInputs.each((_, input) => {
            if (!$(input).val()) {
                $tr.hide();
            }
        });
    });
});